<script setup lang="ts">

import {onMounted} from "vue";

const widgetToken = '92c722978e7e4c329d645b67ecd18fdc';
const scriptSrc = 'https://my.anyday.io/price-widget/anyday-price-widget.js'

const props = defineProps<{
	price: number | string
}>()

function loadScript() {
	if (document.querySelector(`script[src="${scriptSrc}"]`)) return
	const script = document.createElement('script')
	script.src = scriptSrc
	script.type = 'module'
	script.async = true
	document.head.appendChild(script)
}

onMounted(() => {
	loadScript()
})

</script>

<template>
	<anyday-price-widget
		theme="light"
		currency="DKK"
		price-selector=".js-product-price"
		:price="price"
		price-format-locale="da-DK"
		locale="da-DK"
		:token="widgetToken"
		fully-clickable="true"/>
</template>

